<template>
  <v-container fluid>
    <h2 class="mb-4">{{ $t('payments.title') }}</h2>

    <v-row align="center">
      <v-col cols="6" sm="4">
        <label>{{ $t('payments.startDate') }}</label>
        <DatePicker
          class="w-100"
          v-model="startDate"
          @date-selected="startDate=$event.formattedDate; handleDateSelected()"
        />
      </v-col>

      <v-col cols="6" sm="4">
        <label>{{ $t('payments.endDate') }}</label>
        <DatePicker
          class="w-100"
          v-model="endDate"
          @date-selected="endDate=$event.formattedDate; handleDateSelected()"
        />
      </v-col>

      <v-col cols="12" sm="4">
        <label>{{ $t('payments.byContract') }}</label>
        <CustomSelect
          v-model="investmentID"
          @selected="investmentID=$event; fetchPayments()"
        >
          <option value="" selected>{{ $t('payments.all') }}</option>
          <option
            v-for="deal in deals"
            :value="deal.guid"
            :key="deal.guid"
          >
            {{ deal.contractNumber }}
          </option>
        </CustomSelect>
      </v-col>
    </v-row>

    <div v-if="isLoading" class="text-center my-4">
      {{ $t('payments.loading') }}
    </div>

    <div v-else class="rounded-lg table-container mt-8">
      <v-table>
        <tbody>
        <tr
          class="border-0"
          v-for="(payment, index) in payments"
          :key="index"
        >
          <td class="text-no-wrap px-1 text-caption text-sm-body-1 text-center">
            {{ $formatDate(payment.date) }}
          </td>
          <td class="text-center px-1 text-caption text-sm-body-1">
            <v-icon>mdi-credit-card-outline</v-icon>
            {{ $t('payments.contractPayment') }} {{ payment.contract }}
          </td>
          <td class="text-green px-1 text-caption text-sm-body-1 text-center">
            + {{ $formatNumber(payment.amount) }}
          </td>
        </tr>
        </tbody>
      </v-table>
    </div>
  </v-container>
</template>

<script>
import DatePicker from "@/components/DatePicker.vue";
import CustomSelect from "@/components/CustomSelect.vue";
import axios from 'axios';
import { BACKEND_API_ENDPOINT } from "@/api";
import { jwtDecoded } from "@/helpers";

axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('jwtToken')}`;

export default {
  components: {
    CustomSelect,
    DatePicker
  },
  data() {
    return {
      startDate: null,
      endDate: null,
      investmentID: '',
      payments: [],
      isLoading: true,
      deals: [],
    };
  },
  created() {
    const fetchData = async () => {
      try {
        const dealsResponse = await axios.get(BACKEND_API_ENDPOINT + '/retrieve_deals', {
          params: {
            phone_number: this.parsePhoneNumberFromJwt()
          }
        });

        this.deals = dealsResponse.data.Result.deals.map(deal => ({
          guid: deal.guid,
          contractNumber: deal.contractNumber
        }));

        const paymentsResponse = await axios.get(BACKEND_API_ENDPOINT + '/interest_withdrawal_history', {
          params: {
            phoneNumber: this.parsePhoneNumberFromJwt(),
            startDate: '',
            endDate: '',
            byTariffID: '',
            byInvestmentGuid: ''
          }
        });

        this.payments = paymentsResponse.data.Result.interestWithdrawal.map(item => ({
          date: item.date,
          contract: item.contractNumber,
          amount: item.amount
        }));

        this.isLoading = false;
      } catch (error) {
        console.error('Error fetching data:', error);
        this.isLoading = false;
      }
    };

    fetchData();
  },
  methods: {
    async fetchPayments() {
      this.isLoading = true;
      const startDate = this.formatDate(this.startDate);
      const endDate = this.formatDate(this.endDate);

      const requestData = {
        phoneNumber: this.parsePhoneNumberFromJwt(),
        startDate: startDate,
        endDate: endDate,
        byTariffID: null,
        byInvestmentGuid: this.investmentID
      };

      try {
        const response = await axios.get(
          BACKEND_API_ENDPOINT + '/interest_withdrawal_history', {
            params: requestData
          }
        );

        this.payments = response.data.Result.interestWithdrawal.map(item => ({
          date: item.date,
          contract: item.contractNumber,
          amount: item.amount
        }));
      } catch (error) {
        console.error('Error fetching payments:', error);
      } finally {
        this.isLoading = false;
      }
    },
    parsePhoneNumberFromJwt() {
      const payload = jwtDecoded();

      if (payload) {
        return payload.userUUID.replace('+996', '')
      }

      return
    },
    handleDateSelected() {
      if (this.startDate && this.endDate) {
        this.fetchPayments();
      }
    },
    formatDate(dateString) {
      if (dateString) {
        const [day, month, year] = dateString.split('.')

        return `${year}-${month}-${day}`;
      } else {
        return '';
      }
    }
  },
}
</script>

<style scoped>
.table-container {
  max-height: 470px; overflow-y: auto;
}

.table-container::-webkit-scrollbar {
  width: 4px;
}

.table-container::-webkit-scrollbar-thumb {
  background-color: rgba(113, 182, 70, 0.5);
  border-radius: 3px;
}

.table-container::-webkit-scrollbar-thumb:hover {
  background-color: #07a01d;
}
</style>
